const base = window._env_.VUE_APP_HOST

function defaultParams (params) {
  return {
    ...params
  }
}

function defaultConfig (config) {
  return {
    ...config,
    params: defaultParams(config.params),
  }
}

export const getUsers = params => {
  return http.get(`${base}/users`, defaultConfig({ params }))
}
export const getUser = (id, params) => {
  return http.get(`${base}/users/${id}`, defaultConfig({ params }))
}
export const createUser = params => {
  return http.post(`${base}/users`, params)
}
export const updateUser = (id, params) => {
  return http.put(`${base}/users/${id}`, defaultParams(params))
}
export const deleteUser = (id, params) => {
  return http.delete(`${base}/users/${id}`, params)
}
export const restoreUser = (id, params) => {
  return http.post(`${base}/users/${id}/restore`, params)
}
export const restoreClientUser = (id) => {
  return updateUser(id, { is_banned: false })
}

export const deleteClientUser = (id) => {
  return updateUser(id, { is_banned: true })
}
